import React from "react"
import PropTypes from "prop-types"
import { Section, CmsImage } from "@bw/bits"
import { TeaserHorizontal as Teaser } from "@bw/partials"
import { Teasers } from "@bw/modules"
import Map from "./map"
import Search from "./search"
// parse is used to ensure that HTML sent by the CMS is converted to React components
import parse from "html-react-parser"

const ListOfPois = ({ map, search, pois, numberOfColumns }) => {
  const [filteredPois, setFilteredPois] = React.useState(pois)

  React.useEffect(() => {
    setFilteredPois(pois)
  }, [pois])

  return (
    <div>
      {map && <Map {...{ pois, filteredPois }} />}
      <Section>
        {search && <Search {...{ pois, setFilteredPois }} />}
        {filteredPois && filteredPois.length > 0 && (
          <Teasers numberOfColumns={numberOfColumns}>
            {filteredPois.map(poi => {
              const excerpt = poi.getTeaserExcerpt()

              return (
                <Teaser
                  key={poi.id}
                  image={<CmsImage src={poi.teaserImage} alt={poi.title} />}
                  title={poi.title}
                  excerpt={excerpt ? parse(excerpt) : null}
                  to={poi.url}
                />
              )
            })}
          </Teasers>
        )}
      </Section>
    </div>
  )
}

ListOfPois.propTypes = {
  map: PropTypes.bool,
  search: PropTypes.bool,
  pois: PropTypes.arrayOf(PropTypes.object),
  numberOfColumns: PropTypes.number,
}

ListOfPois.propTypes = {
  pois: [],
  numberOfColumns: 3,
}

export { ListOfPois }
